import { fetchGetSellerPayLinkFeeContext } from '@iwoca/lapi-client/iwocapay';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../hooks/useStateKey.hook';

export const usePayLinkFeeContext = () => {
  const { stateKey } = useStateKey();

  const { data, isLoading } = useQuery({
    queryKey: ['fetchGetSellerPayLinkFeeContext'],
    queryFn: () => fetchGetSellerPayLinkFeeContext({ stateKey: stateKey! }),
    enabled: Boolean(stateKey),
  });

  return {
    data,
    isLoading,
  };
};
